export default {
  cn: '中文',
  en: 'English',
}



// WEBPACK FOOTER //
// ./src/lang/base.js